import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class HistoryService {
    private historyLimit = 100;
    private displayLimit = 100;
    isUpdateHistory = false;
    private history$ = new BehaviorSubject<IRouteHistory[]>(
        this.getStorageHistory()
    );

    constructor(private router: Router, private http: HttpClient) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.getQuickMenuSettings().subscribe(quickMenuList => {
                const quickMenuKeys = Object.keys(quickMenuList);
                const path = this.router.url.split('/');
                const actualPath = path[path.length - 1].split('?');
                for (let ele of quickMenuKeys) {
                    if (actualPath[0] === ele) {
                        this.updateHistory();
                        break;
                    }
                }
            });
        });
    }

    getHistory() {
        return this.history$.asObservable().pipe(
            map((history = []) => {

                return history
                    .slice(-1 * this.displayLimit)
                    .map(item =>
                        this.getRouteItem(item))
                    .reverse();
            })
        );
    }

    clearHistory() {
        this.history$.next([]);
        this.setStorageHistory([]);
    }

    getRouteItem(item: any) {
        const urlSplit = item.url.split('/');
        let finalUrl = urlSplit[urlSplit.length - 1];
        let queryParamsObjData = {};
        if (finalUrl.includes('?')) {
            const queryParamsFetch = finalUrl.split('?');
            const queryParamsData = queryParamsFetch[queryParamsFetch.length - 1].split('&');
            queryParamsData.map((ele, index) => {
                const querySplit = ele.split('=');
                // queryParamsObjData += queryParamsData.length - 1 !== index ? querySplit[0] + ':' + querySplit[1] + "," : querySplit[0] + ':' + querySplit[1];
                queryParamsObjData[querySplit[0]] = querySplit[1];
            });
            finalUrl = finalUrl.split('?')[0];
        }
        return {
            url: item.url.split('?')[0],
            text: finalUrl,
            description: item.date,
            icon: this.getIconFromUrl(item.url),
            params: queryParamsObjData,
            actualUrl:item.url
        };
    }

    // private getNameFromUrl(url: string): string {
    //     return !url || url === "/" ? "Home" : `${url.substr(1)}`;
    // }

    private getIconFromUrl(url: string): string {
        return !url || url === "/" ? "home" : "file";
    }

    private getStorageHistory(): IRouteHistory[] {
        return JSON.parse(localStorage.getItem("OneTrust.History") || null) || [];
    }

    private setStorageHistory(history: IRouteHistory[]) {
        localStorage.setItem("OneTrust.History", JSON.stringify(history || []));
    }

    updateHistory() {
        let history: any = this.getStorageHistory();
        if (history.length > this.historyLimit) {
            history = history.slice(0, this.historyLimit);
        }
        if (history.length === this.historyLimit) {
            history = history.slice(1, this.historyLimit);
        }
        const url = this.getCurrentPath();
        const lastRoute = history.length ? history[history.length - 1] : null;
        const lastUrl = lastRoute ? lastRoute.url : "";


        if (url && (!lastUrl || url !== lastUrl)) {
            history.push({ url, date: new Date().toISOString() });
            this.setStorageHistory(history);
        }
        this.history$.next(history);
    }

    private getCurrentPath() {
        const href = this.getHref();
        const origin = this.getOrigin();
        const path = href.substr(origin.length);
        return path;
    }

    private getHref(): string {
        const location = this.getLocation();
        return location.href;
    }

    private getOrigin(): string {
        const location = this.getLocation();
        return location.origin || `${location.protocol}/${location.host}`;
    }

    private getLocation(): Location {
        return window.location;
    }

    private getQuickMenuSettings() {
        try {
            return this.http.get<any>(
                "/assets/json/Design/QuickMenu/quickMenu.json"
            );
        } catch (ex) {
            return null;
        }
    }


}

export interface IRouteHistory {
    url: string;
    date: string;
}

export interface IRouteItem {
    url: string;
    text: string;
    description?: string;
    icon?: string;
}
